import Vue from 'vue';
import billProductTransformer from '../../transformers/creditNoteProduct';
import all from './all';

const success = (data, id, resolve) => {
  all(id);
  resolve();
};

const failed = (errors, reject) => {
  reject(billProductTransformer.fetch(errors));
};

export default (id, billProducts) => (
  new Promise((resolve, reject) => {
    Vue.$http
    .post(`/bills/${id}/products/bulk`, { items: billProductTransformer.sendCollection(billProducts) })
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/billProduct/bulkStore.js